<template>
  <div class="partnership-page">
    <BlogNav />

    <!-- HERO SECTION -->
    <section class="hero">
      <div class="hero-inner">
        <div class="partnership-badge">Partenariat Flit</div>
        
        <!-- Flit logo -->
        <div class="flit-branding">
          <img src="/flit-logo.png" alt="Flit Network" class="flit-logo" />
          <a 
            href="https://www.linkedin.com/company/flit-network" 
            target="_blank" 
            rel="noopener"
            class="flit-link"
          >
            En savoir plus sur Flit →
          </a>
        </div>

        <h1 class="hero-title">
          Query Juriste pour votre équipe juridique
        </h1>
        <p class="hero-subtitle">
          Équipez votre département juridique avec l'IA qui raisonne comme un juriste.
          <strong>Offre exclusive : -10% sur toutes vos licences.</strong>
        </p>

        <div class="hero-cta-group">
          <a
            class="btn btn-primary rounded-pill"
            href="https://calendly.com/d/cytz-wbs-3xn/demo-query-juriste-ia-recherche-juridique"
            @click.prevent="openCalendlyDemo"
            target="_blank"
            rel="noopener"
          >
            Réserver une démo
          </a>
          <a
            class="btn btn-outline rounded-pill"
            href="/contact-flit"
          >
            Nous contacter
          </a>
        </div>

        <div class="discount-highlight">
          <div class="discount-icon">✨</div>
          <div class="discount-text">
            <strong>10% de réduction</strong> sur toutes les licences
          </div>
        </div>
      </div>
    </section>



    <!-- OFFER SECTION -->
    <section class="offer-section">
      <div class="offer-inner">
        <div class="offer-badge">Offre ✨</div>
        <h2 class="offer-title">-10% sur toutes vos licences</h2>
        <p class="offer-description">
          En partenariat avec votre organisation, nous offrons une réduction exclusive de 10% 
          sur toutes les licences pour votre équipe juridique. Plus votre équipe est grande, 
          plus les économies sont importantes.
        </p>

        <div class="offer-features">
          <div class="offer-feature">
            <img class="check" src="@/assets/check.svg" alt="" />
            <span>Accès illimité aux fonctionnalités</span>
          </div>
          <div class="offer-feature">
            <img class="check" src="@/assets/check.svg" alt="" />
            <span>Support prioritaire pour votre équipe</span>
          </div>
          <div class="offer-feature">
            <img class="check" src="@/assets/check.svg" alt="" />
            <span>Onboarding personnalisé</span>
          </div>
          <div class="offer-feature">
            <img class="check" src="@/assets/check.svg" alt="" />
            <span>Tableau de bord administrateur</span>
          </div>
        </div>

        <a
          class="btn btn-primary btn-large rounded-pill"
          href="https://calendly.com/d/cytz-wbs-3xn/demo-query-juriste-ia-recherche-juridique"
          @click.prevent="openCalendlyDemo"
          target="_blank"
          rel="noopener"
        >
          Accéder à cette offre
        </a>
      </div>
    </section>



    <!-- FINAL CTA -->
    <section class="final-cta">
      <div class="cta-content">
        <h2 class="cta-heading">Prêt à équiper votre équipe juridique ?</h2>
        <p class="cta-subheading">
          Réservez une démo personnalisée et découvrez comment Query Juriste 
          peut transformer le travail de votre équipe.
        </p>

        <div class="cta-buttons">
          <a
            class="btn btn-primary btn-large rounded-pill"
            href="https://calendly.com/d/cytz-wbs-3xn/demo-query-juriste-ia-recherche-juridique"
            @click.prevent="openCalendlyDemo"
            target="_blank"
            rel="noopener"
          >
            Planifier une démo
          </a>
          <a
            class="btn btn-ghost btn-large rounded-pill"
            href="/contact-flit"
          >
            Écrire un message
          </a>
        </div>
      </div>
    </section>

    <!-- FOOTER -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-logo-section">
          <img src="/logo-query-juriste-png.png" alt="Query Juriste" class="logo" />
          <p class="footer-description">
            L'IA juridique qui raisonne avec vos besoins.
            Simplifiez vos recherches juridiques.
          </p>
        </div>

        <div class="footer-links-grid">
          <div class="footer-column">
            <h4>Pages</h4>
            <ul>
              <li><a href="https://www.query-juriste.com/">Accueil</a></li>
              <li><a href="https://www.query-juriste.com/blog">Blog</a></li>
              <li><a href="https://www.query-juriste.com/ia">L'IA Query Juriste</a></li>
              <li><a href="https://www.query-juriste.com/faq">FAQ</a></li>
            </ul>
          </div>

          <div class="footer-column">
            <h4>Produit</h4>
            <ul>
              <li><a href="https://www.query-juriste.com/loginPage">Connexion</a></li>
              <li><a href="https://www.query-juriste.com/contactPage">Contact</a></li>
            </ul>
          </div>

          <div class="footer-column">
            <h4>Entreprise</h4>
            <ul>
              <li><a href="https://www.query-juriste.com/mentionsPage">Mentions légales</a></li>
              <li><a href="https://www.query-juriste.com/conditions-utilisation">CGU</a></li>
              <li><a href="https://www.query-juriste.com/conditions-vente">CGV</a></li>
              <li><a href="https://www.query-juriste.com/politique-donnees">Confidentialité</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© 2025 Query Juriste, tous droits réservés</p>
      </div>
    </footer>
  </div>
</template>

<script>
import BlogNav from "@/components/BlogNav.vue";
import { openCalendlyDemo } from "@/utils/calendly";

export default {
  name: "FlitPartnershipPage",
  components: { BlogNav },
  methods: {
    openCalendlyDemo,
  },
  metaInfo() {
    return {
      title: "Partenariat Flit - Query Juriste",
      meta: [
        {
          name: "description",
          content:
            "Équipez votre équipe juridique avec Query Juriste. Offre exclusive : -10% sur toutes les licences. L'IA juridique qui raisonne comme un juriste.",
        },
      ],
      link: [{ rel: "canonical", href: "https://www.query-juriste.com/partenariat-flit" }],
    };
  },
};
</script>

<style scoped>
/* ---------- Tokens ---------- */
:root {
  --bg: #ffffff;
  --text: #1a1a1a;
  --muted: #5e6470;
  --primary: #7e5cf2;
  --primary-600: #625CFB;
  --info: #625CFB;
  --surface: #f7f8fa;
  --border: #e6e8ec;
  --shadow: 0 10px 30px rgba(0,0,0,.12);
  --shadow-sm: 0 4px 16px rgba(0,0,0,.08);
  --radius: 14px;
}

/* ---------- Utilities ---------- */
.text-primary { color: #625CFB; }
.font-bold { font-weight: 700; color: #625CFB; }
.rounded-xl { border-radius: 20px; }
.rounded-pill { border-radius: 999px; }
.shadow-lg { box-shadow: var(--shadow); }
.shadow-sm { box-shadow: var(--shadow-sm); }

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 28px;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform .06s ease, background .2s ease, color .2s ease, border-color .2s ease;
  will-change: transform;
  font-size: 16px;
}
.btn:active { transform: translateY(1px); }
.btn.btn-large { 
  height: 56px; 
  padding: 0 36px; 
  font-size: 18px;
}

.btn-primary {
  background: #625CFB;
  color: #fff;
}
.btn-primary:hover { 
  background: #5147e0;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(98, 92, 251, 0.3);
}

.btn-outline {
  background: transparent;
  border-color: var(--border);
  color: var(--text);
}
.btn-outline:hover {
  border-color: #625CFB;
  color: #625CFB;
  transform: translateY(-2px);
}

.btn-ghost {
  background: transparent;
  border-color: #fff;
  color: #fff;
}
.btn-ghost:hover {
  background: rgba(255,255,255,.15);
  border-color: #fff;
  transform: translateY(-2px);
}

/* ---------- Layout ---------- */
.partnership-page {
  font-family: 'Poppins', ui-sans-serif, system-ui, sans-serif;
  background: var(--bg);
}

/* ---------- HERO ---------- */
.hero {
  padding: 120px 20px 120px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f7ff 0%, #ffffff 100%);
  display: flex;
  align-items: center;
}
.hero-inner {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}
.partnership-badge {
  display: inline-block;
  background: #625CFB;
  color: #fff;
  padding: 8px 20px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.flit-branding {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
}
.flit-logo {
  height: 100px;
  width: auto;
  object-fit: contain;
  border-radius: 12px;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
}
.flit-logo:hover {
  transform: scale(1.05);
}
.flit-link {
  color: #625CFB;
  text-decoration: none;
  font-weight: 500;
  font-size: 15px;
  transition: all 0.2s ease;
}
.flit-link:hover {
  text-decoration: underline;
  color: #5147e0;
}
.hero-title {
  font-size: 2.5em;
  line-height: 1.15;
  margin-bottom: 20px;
  font-weight: 700;
}
.hero-subtitle {
  font-size: clamp(18px, 2.5vw, 22px);
  color: var(--muted);
  margin-bottom: 36px;
  line-height: 1.6;
}
.hero-subtitle strong {
  color: #625CFB;
  font-weight: 600;
}
.hero-cta-group {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 40px;
}
.discount-highlight {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #625CFB 0%, #7e5cf2 100%);
  color: #fff;
  padding: 16px 28px;
  border-radius: 999px;
  box-shadow: 0 8px 24px rgba(98, 92, 251, 0.25);
}
.discount-icon {
  font-size: 24px;
}
.discount-text {
  font-size: 16px;
}
.discount-text strong {
  font-weight: 700;
  color: #fff;
}

/* ---------- BENEFITS SECTION ---------- */
.benefits-section {
  padding: 80px 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.section-header {
  text-align: center;
  margin-bottom: 50px;
}
.link-info {
  color: #625CFB;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
}
.section-heading {
  margin: 12px 0;
  font-size: clamp(28px, 4vw, 44px);
  line-height: 1.2;
}
.section-heading.centered {
  text-align: center;
}
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 28px;
}
.benefit-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 28px;
  transition: all 0.3s ease;
}
.benefit-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow);
  border-color: #625CFB;
}
.benefit-icon {
  font-size: 48px;
  margin-bottom: 16px;
}
.benefit-title {
  font-size: 20px;
  margin-bottom: 12px;
  font-weight: 600;
}
.benefit-text {
  color: var(--muted);
  line-height: 1.6;
  margin: 0;
}

/* ---------- OFFER SECTION ---------- */
.offer-section {
  background: linear-gradient(135deg, #625CFB 0%, #7e5cf2 100%);
  color: #fff;
  padding: 80px 20px;
}
.offer-inner {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}
.offer-badge {
  display: inline-block;
  background: rgba(255,255,255,0.2);
  color: #fff;
  padding: 8px 20px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid rgba(255,255,255,0.3);
}
.offer-title {
  font-size: clamp(28px, 4vw, 42px);
  margin-bottom: 20px;
  font-weight: 700;
}
.offer-description {
  font-size: 18px;
  margin-bottom: 36px;
  line-height: 1.7;
  opacity: 0.95;
}
.offer-features {
  display: grid;
  gap: 16px;
  margin-bottom: 36px;
  text-align: left;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
.offer-feature {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 500;
}
.offer-feature .check {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

/* ---------- HOW IT WORKS ---------- */
.how-it-works {
  padding: 80px 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 32px;
  margin-top: 50px;
}
.step-card {
  text-align: center;
  padding: 32px 24px;
}
.step-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #625CFB 0%, #7e5cf2 100%);
  color: #fff;
  border-radius: 50%;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
  box-shadow: 0 4px 16px rgba(98, 92, 251, 0.3);
}
.step-title {
  font-size: 22px;
  margin-bottom: 12px;
  font-weight: 600;
}
.step-text {
  color: var(--muted);
  line-height: 1.6;
  margin: 0;
}

/* ---------- FINAL CTA ---------- */
.final-cta {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #fff;
  padding: 80px 20px;
}
.cta-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}
.cta-heading {
  font-size: 2em;
  margin-bottom: 16px;
  font-weight: 700;
}
.cta-subheading {
  font-size: 18px;
  margin-bottom: 36px;
  line-height: 1.7;
  opacity: 0.9;
}
.cta-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

/* ---------- FOOTER ---------- */
.footer {
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  padding: 3rem 0 0 0;
}
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 3rem;
  display: flex;
  justify-content: space-between;
  gap: 4rem;
  align-items: start;
}
.footer-logo-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.footer-logo-section .logo {
  height: 60px;
  width: 60px;
  margin-bottom: 0.5rem;
}
.footer-description {
  color: #6b7280;
  font-size: 0.875rem;
  line-height: 1.6;
  margin: 0;
  max-width: 300px;
}
.footer-links-grid {
  display: flex;
  gap: 3rem;
}
.footer-column h4 {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #1a1a1a;
}
.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-column li {
  margin-bottom: 0.75rem;
}
.footer-column a {
  color: #6b7280;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s;
}
.footer-column a:hover {
  color: #625CFB;
}
.footer-bottom {
  border-top: 1px solid #e5e7eb;
  margin-top: 2rem;
  padding: 1.5rem 3rem;
  text-align: center;
}
.footer-bottom p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

/* ---------- Responsive ---------- */
@media (max-width: 900px) {
  .footer-content {
    flex-direction: column;
    gap: 2rem;
  }
  .footer-links-grid {
    flex-wrap: wrap;
    gap: 2rem;
  }
  .benefits-grid {
    grid-template-columns: 1fr;
  }
  .steps-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .hero {
    padding-top: 80px;
  }
  .hero-cta-group {
    flex-direction: column;
    align-items: stretch;
  }
  .btn {
    width: 100%;
  }
  .footer-content {
    padding: 0 1.5rem;
  }
  .footer-bottom {
    padding: 1.5rem;
  }
}
</style>
